import { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import TwoFactor from "@/components/TwoFactor";

export default function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const hasProcessed = useRef(false);
  const [twofa, setTwofa] = useState(null);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = location.hash || window.location.hash;
    const match = hash.match(/session_id=([^&]+)/);
    const sessionId = match ? decodeURIComponent(match[1]) : null;

    const run = async () => {
      if (!sessionId) {
        navigate("/", { replace: true });
        return;
      }
      try {
        const r = await api.post("/auth/session", { session_id: sessionId });
        if (r.data?.twofa_required) {
          window.history.replaceState(null, "", "/");
          setTwofa(r.data);
          return;
        }
        window.history.replaceState(null, "", "/");
        window.location.replace("/");
      } catch (e) {
        window.location.replace("/");
      }
    };
    run();
  }, [location, navigate]);

  if (twofa) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-warm-cream p-6">
        <div className="w-full max-w-md bg-cream border border-ink/15 rounded-2xl p-8 shadow-[0_20px_50px_-25px_rgba(20,20,15,0.4)]">
          <TwoFactor data={twofa} onComplete={() => window.location.replace("/")} />
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-warm-cream">
      <div className="text-center" data-testid="auth-callback-loading">
        <div className="w-12 h-12 border-4 border-maroon border-t-transparent rounded-full animate-spin mx-auto mb-4" />
        <p className="text-ink/70">Signing you in…</p>
      </div>
    </div>
  );
}
